<template>
  <template v-if="!isFAL">
    <InputButton v-if="!isPersonalPage && hasEmail && isValidCountry"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'email' })"
      >Send your CV to this agency
    </InputButton>
    <InputButton v-if="hasEmail && isValidCountry"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'email' })"
      >
        <template v-if="!isPersonalPage">Send a message to this agency</template>
        <template v-else>Email Agency</template>
    </InputButton>
    <InputButton v-if="hasTelephone"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'telfax' })"
      >Display phone number
    </InputButton>
    <InputButton v-if="hasWebsite"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'website' })"
    >
      Visit website
    </InputButton>
    <InputButton
        v-if="agency.social_facebook && (isStatic || isPersonalPage)"
        :block="true"
        :chevron="true"
        styleType="contact"
        @click="$emit('contactFormSelect', { form: 'social', social: 'facebook' })"
    >Visit Facebook
    </InputButton>
    <InputButton
        v-if="agency.social_twitter && (isStatic || isPersonalPage)"
        :block="true"
        :chevron="true"
        styleType="contact"
        @click="$emit('contactFormSelect', { form: 'social', social: 'twitter' })"
    >Visit X (Formerly Twitter) account
    </InputButton>
    <InputButton v-if="!isPersonalPage"
      :block="true"
      styleType="more-info"
      @click="$emit('moreInfoSelect')"
    >More Info
    </InputButton>
  </template>
  <!-- FREE AGENCIES ONLY -->
  <template v-else>
    <InputButton v-if="hasTelephone"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'telfax' })"
    >Display phone number
    </InputButton>
    <InputButton v-if="hasWebsite"
      :block="true"
      :chevron="true"
      styleType="contact"
      @click="$emit('contactFormSelect', { form: 'website' })"
    >
      Visit website
    </InputButton>
    <InputButton
        v-if="agency.social_facebook && (isStatic || isPersonalPage)"
        :block="true"
        :chevron="true"
        styleType="contact"
        @click="$emit('contactFormSelect', { form: 'social', social: 'facebook' })"
    >Visit Facebook
    </InputButton>
    <InputButton
        v-if="agency.social_twitter && (isStatic || isPersonalPage)"
        :block="true"
        :chevron="true"
        styleType="contact"
        @click="$emit('contactFormSelect', { form: 'social', social: 'twitter' })"
    >Visit X (Formerly Twitter) account
    </InputButton>
    <InputButton
        v-if="hasEmail && isValidCountry"
        :block="true"
        :chevron="true"
        styleType="contact"
        @click="$emit('contactFormSelect', { form: 'mailto', social: 'mailto' })"
    >Send an email
    </InputButton>
    <!-- <InputButton v-if="!isPersonalPage && !agency.FAL"
      :block="true"
      styleType="more-info"
      @click="$emit('moreInfoSelect')"
    >More Info
    </InputButton> -->
  </template>
</template>
<script>
import InputButton from 'Components/InputButton.vue';
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'AgencyAdvertContactOptionsCandidate',
  components: { InputButton },
  emits: ['contactFormSelect', 'moreInfoSelect'],
  props: {
    agency: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('pagetext', ['isPersonalPage']),
    ...mapState('search', ['static']),
    ...mapGetters('info', ['isValidCountry']),
    isStatic() {
        return this.static;
    },
    isFAL() {
        return (this.agency.FAL == 'Y' || this.agency.FAL === true) ? true : false;
    },
    hasEmail() {
        // CandEmail contains the number of possible email 
        // addresses for this agency, above zero means yes
        return (this.agency.CandEmail > 0) ? true : false;
    },
    hasTelephone() {
        // CandTelFax contains the number of possible telephone
        // numbers for this agency, above zero means yes
        return (this.agency.CandTelFax > 0) ? true : false;
    },
    hasWebsite() {
        // CandWebsite contains number of possible website addresses
        // this should only ever be 1 or 0 but reserved for future expansion
        return (this.agency.CandWebsite > 0) ? true : false;
    },
  },
};
</script>
